/**
 * Created by tofaelraju on 10/15/17.
 */
import React from 'react';
import PageHeader from '../shared/page-header';
import Badge from 'material-ui/Badge';
import RaisedButton from 'material-ui/RaisedButton';
import {green500, white} from 'material-ui/styles/colors';

const styles = {
  addNewBtn: {
    float: 'right',
    marginRight:10
  },
  badgeOn: {
    fontSize: 12,
    borderRadius: 25,
    width: 55,
    backgroundColor: '#31B181',
  },
  badgeOff: {
    fontSize: 12,
    borderRadius: 25,
    width: 58,
    backgroundColor: '#ff1a1a',
  },
};

const ListTop =({title, createNewButtonLabel='Add new', createNewBadge, onCreateNew})=> (
  <div>
    <PageHeader title={title}/>
    {
      onCreateNew &&
      <RaisedButton
        label={createNewButtonLabel}
        backgroundColor={green500}
        labelColor={white}
        onTouchTap={onCreateNew}
        style={styles.addNewBtn}
      />
    }
    {
     createNewBadge === 'ONLINE' &&
     <Badge
        badgeContent={createNewBadge}
        badgeStyle={styles.badgeOn}
      />
    }
    {
     createNewBadge === 'OFFLINE' &&
     <Badge
        badgeContent={createNewBadge}
        badgeStyle={styles.badgeOff}
      />
    }
  </div>
)
export default ListTop;



// WEBPACK FOOTER //
// ./src/screens/list/list-top.component.js